<template>
    <v-container fluid :class="$vuetify.display.mobile ? 'pa-1' : 'pa-2'">
        <!-- SKELETON -->
        <v-row
            v-if="skeleton"
            @click="emit('click:all')"
            no-gutters
            class="d-flex justify-center w-100"
        >
            <v-col
                v-if="!$vuetify.display.mobile"
                class="oss-card oss-card-left-part oss-card-icon-part"
            >
                <v-skeleton-loader type="avatar" style="margin: 8px" />
            </v-col>
            <v-col
                :class="
                    $vuetify.display.mobile
                        ? 'oss-card oss-card-left-part col-9 py-5'
                        : 'oss-card col-8 pa-5'
                "
            >
                <v-skeleton-loader type="text" />
            </v-col>
            <v-col :cols="$vuetify.display.mobile ? '3' : '2'" class="py-5">
                <v-skeleton-loader type="text" />
            </v-col>
        </v-row>

        <template v-else>
            <template v-if="double">
                <v-row @click="emit('click:all')" no-gutters class="d-flex justify-center">
                    <v-col
                        v-if="!$vuetify.display.mobile && icon"
                        class="oss-card oss-card-left-part oss-card-icon-part"
                    >
                        <v-icon
                            :color="iconColor"
                            class="oss-card-icon"
                            @click.stop="emit('click:icon')"
                            size="x-large"
                        >
                            {{ icon }}
                        </v-icon>
                    </v-col>
                    <v-col
                        v-if="!$vuetify.display.mobile && txtIcon"
                        class="oss-card oss-card-left-part oss-card-icon-part"
                    >
                        <div class="avatar primary--text">
                            {{ txtIcon }}
                        </div>
                    </v-col>
                    <v-col
                        :class="
                            $vuetify.display.mobile || (!icon && !txtIcon)
                                ? 'oss-card oss-card-left-part col-9'
                                : 'oss-card col-8 d-flex align-center flex-shrink-1 flex-grow-0'
                        "
                    >
                        <slot name="left" />
                    </v-col>
                    <v-col
                        :cols="$vuetify.display.mobile ? '3' : '2'"
                        class="d-flex align-center justify-center flex-shrink-0 flex-grow-1"
                    >
                        <template v-if="right">
                            <slot name="right" />
                        </template>
                        <div v-else class="pr-4">
                            <v-row v-if="!!amount" no-gutters>
                                <template v-if="$vuetify.display.mobile">
                                    <v-col
                                        cols="12"
                                        :class="
                                            'd-flex align-center justify-end py-2 ' + amountStyle
                                        "
                                    >
                                        <span
                                            style="min-width: 94px"
                                            :class="
                                                amount < 0
                                                    ? 'new_red--text text-right'
                                                    : 'secondary--text text-right'
                                            "
                                        >
                                            {{
                                                isNaN(amount)
                                                    ? "-"
                                                    : newCommonFormatCurrency(amount, undefined)
                                            }}
                                        </span>
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col
                                        cols="12"
                                        :class="
                                            'd-flex align-center justify-center py-2 ' + amountStyle
                                        "
                                    >
                                        <span
                                            style="min-width: 120px"
                                            :class="
                                                amount < 0
                                                    ? 'new_red--text text-center'
                                                    : 'secondary--text text-center'
                                            "
                                        >
                                            {{
                                                isNaN(amount)
                                                    ? "-"
                                                    : newCommonFormatCurrency(amount, undefined)
                                            }}
                                        </span>
                                    </v-col>
                                </template>
                            </v-row>
                            <v-row v-if="!!tagText" no-gutters>
                                <v-col
                                    cols="12"
                                    :class="
                                        $vuetify.display.mobile
                                            ? 'd-flex align-center justify-end py-2'
                                            : 'd-flex align-center justify-end py-2'
                                    "
                                    :style="
                                        $vuetify.display.mobile
                                            ? 'min-width: 94px'
                                            : 'min-width: 120px'
                                    "
                                >
                                    <v-btn
                                        :class="tagStyle"
                                        :color="tagColor"
                                        :rounded="roundedTag"
                                        :outlined="outlinedTag"
                                        :fab="fabTag"
                                        :x-small="$vuetify.display.mobile"
                                        :small="!$vuetify.display.mobile"
                                        :block="!$vuetify.display.mobile"
                                        @click.stop="
                                            unclickableTag ? emit('click:all') : emit('click:tag')
                                        "
                                    >
                                        {{ tagText }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-if="!!tagIcon" no-gutters>
                                <v-col
                                    cols="12"
                                    :class="
                                        $vuetify.display.mobile
                                            ? 'd-flex align-center justify-end py-2'
                                            : 'd-flex align-center justify-end py-2'
                                    "
                                    :style="
                                        $vuetify.display.mobile
                                            ? 'min-width: 94px'
                                            : 'min-width: 120px'
                                    "
                                >
                                    <v-btn
                                        :class="tagStyle"
                                        :color="tagColor"
                                        :rounded="roundedTag"
                                        :outlined="outlinedTag"
                                        :fab="fabTag"
                                        :x-small="$vuetify.display.mobile"
                                        :small="!$vuetify.display.mobile"
                                        :block="!$vuetify.display.mobile"
                                        @click.stop="
                                            unclickableTag ? emit('click:all') : emit('click:tag')
                                        "
                                    >
                                        <v-icon>{{ tagIcon }}</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="$vuetify.display.mobile">
                    <v-col cols="12">
                        <v-divider />
                    </v-col>
                </v-row>
            </template>

            <v-row v-else no-gutters @click="emit('click:all')">
                <v-col class v-if="!$vuetify.display.mobile && icon">
                    <v-icon
                        :color="iconColor"
                        class="oss-card-icon"
                        @click.stop="emit('click:icon')"
                        size="x-large"
                    >
                        {{ icon }}
                    </v-icon>
                </v-col>
                <v-col
                    :class="
                        $vuetify.display.mobile || !icon
                            ? 'oss-card oss-card-full-part'
                            : 'oss-card oss-card-right-part'
                    "
                >
                    <slot />
                </v-col>
            </v-row>
        </template>

        <template v-slot:right v-if="actionsPart">
            <slot name="actions" />
        </template>
    </v-container>
</template>

<script lang="ts">
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        SwipeOut,
        SwipeList,
    },
})
export class ossCard extends Vue {
    @Prop({ default: null }) icon;
    @Prop({ default: "primary" }) iconColor;
    @Prop({ default: null }) amount;
    @Prop({ default: "" }) amountStyle;
    @Prop({ default: null }) tagText;
    @Prop({ default: "" }) tagStyle;
    @Prop({ default: "secondary" }) tagColor;
    @Prop({ default: false }) roundedTag;
    @Prop({ default: false }) outlinedTag;
    @Prop({ default: false }) fabTag;
    @Prop({ default: false }) skeleton;
    @Prop({ default: false }) unclickableTag;
    @Prop({ default: null }) swipeBtnStyle;
    @Prop({ default: null }) txtIcon;

    get actionsPart() {
        return (
            (!!this.$slots.actions || (this.swipeBtnStyle && this.swipeBtnStyle.length)) &&
            this.$vuetify.display.mobile
        );
    }

    get right() {
        debugger;
        return !!this.$slots.right;
    }

    get defaultRight() {
        return !!this.tagText || !!this.tagStyle || !!this.amount;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get double() {
        return !!this.amount || this.right || !!this.tagText;
    }

    emit(emit) {
        this.$emit(emit);
    }
}

export default toNative(ossCard);
</script>
